import { isEmail } from "../../../utils/validation";

export function isTravelokaEmailDetected(email: string) {
  return isEmail(email) && email.endsWith("@traveloka.com");
}
